

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'https://192.168.0.140:7258';



